import {useState, useEffect} from 'react'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Dropdown, Modal, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../../utils/helpers/FormGenerator'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import {dateTimeFormat, timestampsFormat} from 'thesis-and-dissertations/helpers/helper'
const api = new Api()

const heads = [
  {
    name: '',
    label: 'Nama',
  },
  {
    name: '',
    label: 'Tanggal Mulai',
  },
  {
    name: '',
    label: 'Tanggal Akhir',
  },
  {
    name: '',
    label: 'Status',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const inputs = [
  {
    name: 'nama_batch',
    label: 'Nama Batch',
    type: 'text',
    validation: {},
    col: 12,
    options: [],
    additional: '',
  },
  {
    name: 'tanggal_mulai',
    label: 'Tanggal Mulai',
    type: 'datetime-local',
    validation: {},
    col: 12,
    options: [],
    additional: '',
  },
  {
    name: 'tanggal_akhir',
    label: 'Tanggal Akhir',
    type: 'datetime-local',
    validation: {},
    col: 12,
    options: [],
    additional: '',
  },
  {
    name: 'is_active',
    label: 'Status',
    type: 'select',
    validation: {},
    col: 12,
    options: [
      {
        name: 'Pilih Status',
        value: '',
      },
      {
        name: 'Aktif',
        value: '1',
      },
      {
        name: 'Non-Aktif',
        value: '0',
      },
    ],
    getItemValue: 'name',
    getItemValueId: 'value',
    additional: '',
  },
]

const PanaRegistrationPeriodPage = () => {
  const [data, setData] = useState<any>([])
  const [publishData, setPublishData] = useState<any>({})
  const [errors, setErrors] = useState<any>({})
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [show, setShow] = useState<boolean>(false)
  const [formValue, setFormValue] = useState<any>({
    waktu_publish_wawancara: null,
    waktu_publish: null,
  })
  const [query, setQuery] = useState<any>({})

  useEffect(() => {
    fetchPanaBatch({...query})
    fetchPublishTime({...query})
  }, [query])

  const toggle = () => {
    if (show) {
      setFormValue({})
    }
    setShow(!show)
  }

  const fetchPublishTime = (params = {}) => {
    setIsLoading(true)
    api
      .getPublisTime({...params})
      .then((response: any) => {
        setIsLoading(false)
        const data = response.data
        setFormValue({
          ...formValue,
          waktu_publish: timestampsFormat(data?.data?.waktu_publish),
          waktu_publish_wawancara: timestampsFormat(data?.data?.waktu_publish_wawancara),
        })
      })
      .catch((error: any) => {
        const {data} = error.response
        setErrors(data?.meta?.error)
        setIsLoading(false)
      })
  }

  const updatePublishTime = () => {
    setIsLoading(true)
    formValue['waktu_publish'] = timestampsFormat(formValue?.waktu_publish) ?? null
    formValue['waktu_publish_wawancara'] = timestampsFormat(formValue?.waktu_publish_wawancara) ?? null
    api
      .savePublishTime(formValue)
      .then((response: any) => {
        const {data} = response
        setIsLoading(false)
        toast.success(data?.meta?.message)
      })
      .catch((error: any) => {
        const {data, status} = error.response
        setErrors(data.errors)
        setIsLoading(false)
        toast.error(data.message)
      })
  }

  const fetchPanaBatch = (params = {}) => {
    setIsLoading(true)
    api
      .getPanaBatch({...params})
      .then((response: any) => {
        setIsLoading(false)
        const data = response.data
        setData(data.data)
      })
      .catch((error: any) => {
        const {data} = error.response
        setErrors(data?.meta?.error)
        setIsLoading(false)
      })
  }

  const onChange = (e: any) => {
    const {name, value} = e.target
    setFormValue({...formValue, [name]: value})
    setErrors({})
  }

  const onSubmit = async (e: any) => {
    e?.preventDefault()
    if (formValue?.id) {
      actionUpdate()
      return
    }

    actionCreate()
  }

  const actionCreate = () => {
    setIsLoading(true)
    formValue.tanggal_mulai = dateTimeFormat(formValue.tanggal_mulai)
    formValue.tanggal_akhir = dateTimeFormat(formValue.tanggal_akhir)

    api
      .addPanaBatch(formValue)
      .then((response: any) => {
        setIsLoading(false)
        toggle()
        toast.success(response?.data?.meta?.message)
        fetchPanaBatch()
      })
      .catch((error: any) => {
        const {data, status} = error.response
        setErrors(data.errors)
        setIsLoading(false)
        toast.error(data.message)
      })
  }

  const actionUpdate = () => {
    setIsLoading(true)
    formValue.tanggal_mulai = dateTimeFormat(formValue.tanggal_mulai)
    formValue.tanggal_akhir = dateTimeFormat(formValue.tanggal_akhir)

    api
      .updatePanaBatch(formValue, formValue?.id)
      .then((response: any) => {
        setIsLoading(false)
        toggle()
        toast.success(response?.data?.meta?.message)
        fetchPanaBatch()
      })
      .catch((error: any) => {
        const {data, status} = error.response
        setErrors(data.errors)
        setIsLoading(false)
        toast.error(data.message ?? data?.meta?.message)
      })
  }

  return (
    <>
      <div className='card'>
        <div className='p-7 border-bottom'>
          <div className='d-flex align-items-center gap-3'>
            <p className='fs-4 fw-bold'>Periode Registrasi</p>
          </div>
        </div>
        <div className='px-8'>
          <div className='row'>
            <Modal show={show} onHide={toggle} size='lg'>
              <Modal.Header closeButton>
                <Modal.Title>DETAIL {formValue?.title_id}</Modal.Title>
              </Modal.Header>
              <Form onSubmit={onSubmit}>
                <Modal.Body>
                  <Row>{FormGenerator(inputs, formValue, onChange)}</Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant='secondary' onClick={toggle}>
                    Batalkan
                  </Button>
                  <Button variant='primary' type='submit' disabled={isLoading}>
                    {isLoading ? 'Loading' : 'Simpan'}
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>

            <div className='col-md-12 mt-9'>
              <Row>
                <Col md={{span: 4}}>
                  <Form.Control
                    placeholder='Cari...'
                    name='q'
                    onChange={(e) => setQuery({...query, q: e.target.value})}
                  />
                </Col>
                <Col md={{span: 2, offset: 4}}>
                  <button type='button' onClick={toggle} className='btn btn-primary form-control'>
                    + Tambah
                  </button>
                </Col>
                <Col md={{span: 2}}>
                  <select
                    className='mr-8 form-control'
                    onChange={(e) => {
                      setQuery({...query, sort_order: e.target.value})
                    }}
                  >
                    <option value='desc'>Terbaru</option>
                    <option value='asc'>Terlama</option>
                  </select>
                </Col>
              </Row>

              <Row md={12} className='mt-8'>
                <div className='table-responsive'>
                  <table className='table table-striped align-middle'>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Tanggal</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((item: any, key: any) => {
                        return (
                          <tr key={key}>
                            <td>{key + 1}</td>
                            <td>{item?.nama_batch}</td>
                            <td>{item?.tanggal_mulai}</td>
                            <td>{item?.tanggal_akhir}</td>
                            <td>
                              {item.is_active == 1 ? (
                                <button className='shadow-none btn btn-sm btn-outline btn-outline-success'>
                                  Aktif
                                </button>
                              ) : (
                                <button className='shadow-none btn-sm btn-sm btn-outline btn-outline-dark'>
                                  Nonaktif
                                </button>
                              )}
                            </td>
                            <td>
                              <button
                                className='btn btn-primary btn-sm'
                                onClick={() => {
                                  setFormValue({
                                    nama_batch: item?.nama_batch,
                                    tanggal_mulai: item?.tanggal_mulai,
                                    tanggal_akhir: item?.tanggal_akhir,
                                    is_active: item?.is_active,
                                    id: item?.id,
                                  })
                                  toggle()
                                }}
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </Row>
            </div>
          </div>
        </div>
      </div>

      <div className='card mt-8'>
        <div className='p-7 border-bottom'>
          <div className='d-flex align-items-center gap-3'>
            <p className='fs-4 fw-bold'>Waktu Publish</p>
          </div>
        </div>
        <div className='p-8'>
          <div className='row mt-2'>
            <div className='col-12'>
              <p>Waktu Publish Kelulusan</p>
              <input
                type='datetime-local'
                name='waktu_publish'
                className={`form-control mt-3 ${errors?.waktu_publish && 'border-danger'} `}
                onChange={(e: any) => onChange(e)}
                value={formValue?.waktu_publish}
              />
              {errors?.waktu_publish && <p className='text-danger'>{errors?.waktu_publish}</p>}
            </div>

            <div className='col-12 mt-8'>
              <p>Waktu Publish Wawancara</p>
              <input
                type='datetime-local'
                name='waktu_publish_wawancara'
                className={`form-control mt-3 ${
                  errors?.waktu_publish_wawancara && 'border-danger'
                } `}
                onChange={(e: any) => onChange(e)}
                value={formValue?.waktu_publish_wawancara}
              />
              {errors?.waktu_publish_wawancara && (
                <p className='text-danger'>{errors?.waktu_publish_wawancara}</p>
              )}
            </div>
            <div className='col-12'>
              <button
                className='btn mt-8 btn-primary btn-sm w-100'
                disabled={isLoading}
                onClick={() => updatePublishTime()}
              >
                {isLoading ? 'Loading...' : 'Simpan'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const PanaRegistrationPeriod = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Periode Registrasi PANA
      </PageTitle>
      <PanaRegistrationPeriodPage />
    </>
  )
}

export default PanaRegistrationPeriod
